import { useTranslation } from "react-i18next";
import { useAgreementData } from "../../hooks";
import { AgreementDataSection, AgreementFields } from "../shared";
import { CollapsibleSection } from "@/components/CollapsibleSection";

const questionnaireFields: AgreementFields = [
  { key: "last_name" },
  { key: "first_name" },
  { key: "full_name" },
  { key: "city" },
  { key: "postal_code" },
  { key: "post_office" },
  { key: "street", type: "textarea" },
  { key: "house_number" },
  { key: "apartment_number" },
  { key: "province_name" },
  { key: "province_nfz_code" },
  { key: "province_nfz_description" },
  { key: "county" },
  { key: "municipality" },
  { key: "email" },
  { key: "phone" },
  { key: "birth_date" },
  { key: "birth_place" },
  { key: "personal_id_number" },
  { key: "gender", valueTranslationPrefix: "gender.code" },
  { key: "bank_account_number" },
  { key: "tax_office_name" },
  { key: "citizenship_name" },
  { key: "disability_certificate_code" },
  { key: "rodo_accepted", type: "boolean" },
  { key: "regulations_accepted", type: "boolean" },
] as const;

export const AgreementQuestionnaireSection = () => {
  const { t } = useTranslation();
  const { draft, non_draft } = useAgreementData();

  return (
    <CollapsibleSection title={t("agreements.questionnaire.title")}>
      <AgreementDataSection
        title=""
        fields={questionnaireFields}
        draftData={draft}
        confirmedData={non_draft}
        translationPrefix="questionnaires.form.fields"
      />
    </CollapsibleSection>
  );
};
